import gql from 'graphql-tag';

export default gql`
  query {
    courses {
      name
      prio
      price
      isGroup
      imageUrl
      displayName
      description
      username: presenterName
      userImageUrl: presenterLogo

      courseModules {
        url
        prio
        name
        imageUrl
        position
        isWatched
        handoutUrl
        displayName
        subtitleUrl
        description
      }

      courseChapters {
        name
        prio
        displayName
        description

        courseModules {
          url
          name
          prio
          imageUrl
          position
          isWatched
          handoutUrl
          displayName
          subtitleUrl
          description
        }
      }
    }
  }
`;
